// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__v2a48","opacity-transition":"error_opacity-transition__JaSul"};